export default "__VITE_ASSET__jR_IFDZn__"